// @ts-nocheck
import { AlternatePackagingCollectionModel } from "@insite/client-framework/Types/ApiModels";
import {
    getAlternatePackaging,
    GetAlternatePackagingApiParameter,
} from "@store/Framework/Services/AlternatePackagingService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import merge from "lodash/merge";

type HandlerType = ApiHandler<GetAlternatePackagingApiParameter, AlternatePackagingCollectionModel>;

export const DispatchBeginLoadAlternatePackaging: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/AlternatePackaging/BeginLoadAlternatePackaging",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getAlternatePackaging(props.apiParameter);
    if (result.successful) {
        props.apiResult = merge(result.result, {
            id: "",
            uri: "",
            properties: {},
        });
    } else {
        props.dispatch({
            type: "Greif/Data/AlternatePackaging/FailedToLoadAlternatePackaging",
            model: { ...props.apiResult },
        });
    }
};

export const DispatchCompleteLoadAlternatePackaging: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/AlternatePackaging/CompleteLoadAlternatePackaging",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadAlternatePackaging,
    RequestDataFromApi,
    DispatchCompleteLoadAlternatePackaging,
];

const loadProductAlternatePackaging = createHandlerChainRunner(chain, "LoadAlternatePackaging");
export default loadProductAlternatePackaging;
